import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { Button } from 'react-bootstrap'

const ModalDescripcionEmpresa = ({ tienda, setTienda, onActualizarDescripcion }) => {
  const [descripcionTienda, setDescripcionTienda] = useState('')
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (tienda.descripcionTienda !== descripcionTienda) {
      setDescripcionTienda(tienda.descripcionTienda || '')
    }
  }, [tienda.descripcionTienda, descripcionTienda])

  const manejarModal = useCallback(() => {
    setShow((prev) => !prev)
  }, [])

  const handleAgregarDescripcion = (e) => {
    const newValue = e.target.value
    setDescripcionTienda(newValue)
    if (tienda.idTiendaOficial > 0) {
      setTienda((prev) => ({
        ...prev,
        descripcionTienda: newValue
      }))
    }
  }

  const modificacion = () => {
    onActualizarDescripcion()
    manejarModal()
  }

  const cancelarCambio = useCallback(() => {
    setDescripcionTienda(tienda.descripcionTienda || '')
    manejarModal()
  }, [tienda.descripcionTienda, manejarModal])

  return (
    <div>
      <Button
        data-target="#descripcionEmpresa"
        data-toggle="modal"
        variant="datos-perfil"
        onClick={manejarModal}
      >
        <span className="float-left">Descripción de Empresa</span>
        <span className="float-right">
          <i
            className={`fa ${
              tienda.descripcionTienda === null
                ? 'fa-times f-red'
                : 'fa-check f-ebm-green'
            }`}
          />
        </span>
      </Button>

      {show && (
        <div
          className="modal fade show d-block"
          role="dialog"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={manejarModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: '50%', height: '90%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content h-100">
              <div className="modal-header">
                <h5 className="modal-title">Agregar Descripción de la Empresa</h5>
                <button
                  type="button"
                  className="close btn-close"
                  aria-label="Cerrar"
                  onClick={manejarModal}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '1.5rem',
                    lineHeight: 1,
                    cursor: 'pointer'
                  }}
                >
                  <span aria-hidden="true">x</span>
                </button>
              </div>
              <div className="modal-body flex-grow-1">
                <textarea
                  className="form-control"
                  value={descripcionTienda}
                  name="descripcionTienda"
                  onChange={handleAgregarDescripcion}
                  cols="30"
                  rows="10"
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={cancelarCambio}
                >
                  Cerrar
                </button>
                <button type="button" className="btn btn-primary" onClick={modificacion}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

ModalDescripcionEmpresa.propTypes = {
  tienda: PropTypes.shape({
    descripcionTienda: PropTypes.string,
    idTiendaOficial: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  setTienda: PropTypes.func.isRequired,
  onActualizarDescripcion: PropTypes.func.isRequired
}

export default ModalDescripcionEmpresa
